import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageTitle: {
    id: "connection-manager: page title",
    defaultMessage: "Connections and data",
  },
  pageDescription: {
    id: "connection-manager: page description",
    defaultMessage: "Connect all the platforms that apply. More data helps us assess your application accurately.",
  },
  onlineSalesHeading: {
    id: "connection-manager: online sales heading",
    defaultMessage: "Online sales",
  },
  onlineSalesBannerBlockedSingle: {
    id: "connection-manager: online sales banner blocked single",
    defaultMessage: "Your {platformName} store is disconnected. Reconnect to continue.",
  },
  onlineSalesBannerSameConnectorCovered: {
    id: "connection-manager: online sales banner same connector covered",
    defaultMessage:
      "One of your {platformName} stores is disconnected. You can still continue, but you may need to reconnect it later.",
  },
  onlineSalesBannerOtherConnectorCovered: {
    id: "connection-manager: online sales banner other connector covered",
    defaultMessage:
      "Your {platformName} store is disconnected. You can still continue, but you may need to reconnect it later.",
  },
  onlineSalesBannerMultiplePlatforms: {
    id: "connection-manager: online sales banner multiple platforms",
    defaultMessage:
      "Some of your stores are disconnected. You can still continue, but you may need to reconnect them later.",
  },
  onlineSalesDisconnectedSubtitle: {
    id: "connection-manager: online sales disconnected subtitle",
    defaultMessage: "Disconnected",
  },
  accountingHeading: {
    id: "connection-manager: accounting heading",
    defaultMessage: "Accounting",
  },
  marketingHeading: {
    id: "connection-manager: marketing heading",
    defaultMessage: "Marketing",
  },
  marketingBannerSinglePlatform: {
    id: "connection-manager: marketing banner single platform",
    defaultMessage:
      "Your {platformName} is disconnected. You can still continue, but you may need to reconnect it later.",
  },
  marketingBannerMultiplePlatforms: {
    id: "connection-manager: marketing banner multiple platforms",
    defaultMessage:
      "Your {platformNames} are {count, plural, =2 {both} other {all}} disconnected. You can still continue, but you may need to reconnect them later.",
  },
  marketingDisconnectedSubtitle: {
    id: "connection-manager: marketing disconnected subtitle",
    defaultMessage: "Disconnected",
  },
  combinedBannerBlocking: {
    id: "connection-manager: combined banner blocking",
    defaultMessage: "Some of your connections are disconnected. Reconnect to continue.",
  },
  combinedBannerNonBlocking: {
    id: "connection-manager: combined banner non blocking",
    defaultMessage:
      "Some of your connections are disconnected. You can still continue, but you may need to reconnect them later.",
  },
  otherPlatform: {
    id: "connection-manager: other platform",
    defaultMessage: "Other",
  },
  anyDoubtsHeading: {
    id: "connection-manager: need help connecting heading",
    defaultMessage: "Need help connecting?",
  },
  helpFooter: {
    id: "funding-application: connection manager next help footer",
    defaultMessage:
      "<p><a1>Invite a team member</a1> to connect on your behalf, or <a2>talk to our team</a2> for support.</p>",
  },
  learnMoreText: {
    id: "connection-manager: learn more text",
    defaultMessage: "Learn more about <link>why do we need access to your platforms</link>.",
  },
  connectPlatformTitle: {
    id: "connection-manager: connect platform title",
    defaultMessage: "Connect {platformName}",
  },
  nextLabel: {
    id: "connection-manager: next button label",
    defaultMessage: "Additional statements",
  },
  backLabel: {
    id: "connection-manager: back button label",
    defaultMessage: "Bank account connection",
  },
  viewMoreLabel: {
    id: "connection-manager: show more label",
    defaultMessage: "Show more",
  },
  connectionCount: {
    id: "connection-manager: connection count",
    defaultMessage: "{count, plural, one {# connection} other {# connections}}",
  },
  platformNotListedModalTitle: {
    id: "connection-manager: platform not listed modal title",
    defaultMessage: "My platform isn't listed",
  },
  accountingNotListedModalDescriptionP1: {
    id: "connection-manager: accounting not listed modal description p1",
    defaultMessage:
      "No problem — we'll add an accounting documents step to your application, which you'll see appear in your progress tracker.",
  },
  accountingNotListedModalDescriptionP2: {
    id: "connection-manager: accounting not listed modal description p2",
    defaultMessage:
      "We'll ask you to upload your Profit & Loss Statement and Balance Sheet (Excel or PDF), which helps us assess your application alongside your banking data.",
  },
  continueApplicationLabel: {
    id: "connection-manager: continue application button label",
    defaultMessage: "Continue",
  },
  codatPlatformSelectionModalTitle: {
    id: "connection-manager: codat platform selection modal title",
    defaultMessage: "Select your accounting platform",
  },
  codatPlatformSelectionModalDescription: {
    id: "connection-manager: codat platform selection modal description",
    defaultMessage: "Select the accounting platform you use. Once connected, we'll use it to support your application.",
  },
  codatPlatformSelectionDropdownLabel: {
    id: "connection-manager: codat platform selection dropdown label",
    defaultMessage: "Platform",
  },
  cancelLabel: {
    id: "connection-manager: cancel label",
    defaultMessage: "Cancel",
  },
  uploadAccountingDocumentsLabel: {
    id: "connection-manager: upload accounting documents tile label",
    defaultMessage: "Upload",
  },
  uploadAccountingDocumentsPanelTitle: {
    id: "connection-manager: upload accounting documents panel title",
    defaultMessage: "Upload accounting documents",
  },
  missingProfitAndLossError: {
    id: "connection-manager: missing profit and loss upload error",
    defaultMessage: "Upload your profit and loss statement(s).",
  },
  missingBalanceSheetError: {
    id: "connection-manager: missing balance sheet upload error",
    defaultMessage: "Upload your balance sheet(s).",
  },
  missingAccountingCurrencyError: {
    id: "connection-manager: missing accounting currency error",
    defaultMessage: "Select a reporting currency.",
  },
  uploadFileCount: {
    id: "connection-manager: upload file count label",
    defaultMessage: "{count, plural, one {# file} other {# files}}",
  },
  accountingUploadPanelDescription: {
    id: "connection-manager: accounting upload panel description",
    defaultMessage:
      "We need your profit and loss statement and balance sheet for the last 18 months, broken down by month. Have 24 months? Add it, it gives us a clearer picture and means we're less likely to follow up.",
  },
  reportingCurrencyHelperSlideoutText: {
    id: "funding-application: slideout reporting currency helper text",
    defaultMessage: "The currency used in your statements",
  },
  plExampleLink: {
    id: "connection-manager: profit and loss example link",
    defaultMessage: "You can view an example profit & loss statement <a>here</a>.",
  },
  bsExampleLink: {
    id: "connection-manager: balance sheet example link",
    defaultMessage: "You can view an example balance sheet <a>here</a>.",
  },
  documentUploadProfitAndLossTitle: {
    id: "connection-manager: accounting doc upload pnl",
    defaultMessage: "Profit and loss statement(s)",
  },
  documentUploadBalanceSheetTitle: {
    id: "connection-manager: accounting doc upload bs",
    defaultMessage: "Balance sheet(s)",
  },
});
